module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/preview_en-525c88ea3e15ade2330dabd89c9b2dcf.gif";